import { cityDomain } from '@city';
import { FormValues } from '.';

export const getDefaultValues = (data?: cityDomain.City | null): FormValues => {
  return {
    name: data?.name ?? '',
    timezone: data?.timezone ?? null,
  };
};
